import { render } from "./Infirmary.vue?vue&type=template&id=09057488"
import script from "./Infirmary.vue?vue&type=script&lang=js"
export * from "./Infirmary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__